/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Export_WordsInputs */

const en_us2_search_field_export_words = /** @type {(inputs: Search_Field_Export_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`export data gdpr download backup`)
};

const pt_br2_search_field_export_words = /** @type {(inputs: Search_Field_Export_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exportar dados lgpd baixar download backup`)
};

const es_419_search_field_export_words = /** @type {(inputs: Search_Field_Export_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exportar datos privacidad descargar respaldo backup`)
};

const pt_pt2_search_field_export_words = /** @type {(inputs: Search_Field_Export_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exportar dados rgpd transferir download copia backup`)
};

const fr_fr2_search_field_export_words = /** @type {(inputs: Search_Field_Export_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exporter donnees rgpd telecharger sauvegarde`)
};

const de_de2_search_field_export_words = /** @type {(inputs: Search_Field_Export_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exportieren daten dsgvo download herunterladen backup`)
};

const it_it2_search_field_export_words = /** @type {(inputs: Search_Field_Export_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esporta dati gdpr scarica download backup`)
};

/**
* | output |
* | --- |
* | "export data gdpr download backup" |
*
* @param {Search_Field_Export_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_export_words = /** @type {((inputs?: Search_Field_Export_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Export_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_export_words(inputs)
	if (locale === "es-419") return es_419_search_field_export_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_export_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_export_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_export_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_export_words(inputs)
	return en_us2_search_field_export_words(inputs)
});
export { search_field_export_words as "search.field_export_words" }